@use "Styles/includes/variables";

:host {
    display: block;
}

// Shadow DOM does not inherit the page's Bootstrap reboot, so the relevant
// element resets the light-DOM markup relies on are copied here from
// `bootstrap/4.0.0-beta.2` reboot.
*,
*::before,
*::after {
    box-sizing: border-box;
}

img {
    vertical-align: middle;
    border-style: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}

a {
    text-decoration: none;
    background-color: transparent;
}

/* Related item — ported from `video_item_short.html`'s `.related-item` markup. */
.related-item {
    display: flex;
    width: 100%;
    padding: 4px;
    margin-bottom: 5px;
}

.related-item__img {
    max-width: 150px;
}

.related-item__img-container {
    position: relative;
    margin-right: 10px;
    width: 150px;
    max-height: 105px; /* Needed for proper item overlay placement */
    min-width: 150px;
    text-align: center;

    a {
        display: block;
    }
}

.related-item__info {
    width: 100%;
}

.related-item__author {
    font-family: variables.$fontPrimary;
    font-size: 12px;
    letter-spacing: 0.17px;
    text-align: left;
    color: #8b8d92;
    text-transform: uppercase;

    a {
        color: #8b8d92;
    }
}

.related-item__title {
    margin-bottom: 2px;
    font-family: variables.$fontPrimary;
    font-size: 1.1em;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: 0.1px;
    text-align: left;
    color: #20262b;

    a {
        color: #222;
        font-size: 0.8em;
        line-height: 1.1;

        &:hover {
            color: #0092db;
            text-decoration: none;
        }
    }
}

.related-item__desc {
    font-family: variables.$fontPrimary;
    font-size: 12px;
    letter-spacing: 0.1px;
    text-align: left;
    color: #a4a4a4;

    a {
        color: #a4a4a4;
    }
}

.float-right {
    float: right;
}

/* Overlay on images — ported from `.img-overlay` / `.overlay.video-duration`. */
.img-overlay {
    position: relative;
    display: inline-block;
}

.overlay {
    position: absolute;
    bottom: 5px;
    right: 5px;
    font-size: 12px;
    background-color: black;
    color: white;
    line-height: 14px;
    opacity: 0.75;
    font-weight: bold;
    padding: 0 4px;
    display: inline-block;
}

.overlay.video-duration {
    display: inline-block;
    border-radius: 20px;
    padding: 2px 6px;
}

a:hover .overlay {
    display: none;
}

a:hover .overlay.video-duration {
    display: inline-block;
}
